<template>
 <b-card no-body>
      <b-tabs 
        v-model="tabIndex"
        :card="card"
      >
        <slot></slot>
      </b-tabs>
    </b-card>
</template>

<script>


export default {
  name: 'SGPMainTabComponent',

  props: {
    card: {
      type: Boolean,
      required: false,
      default: true
    },
    tabIndex: {
      type: Number,
      required: false,
      default: 0
    }
  }
}
</script>